import React from 'react'

/**
 * Composant de boîte de dialogue de confirmation pour les formulaires
 * 
 * @param {Object} props - Propriétés du composant
 * @param {boolean} props.show - Indique si la boîte de dialogue doit être affichée
 * @param {Function} props.onConfirm - Fonction appelée lors de la confirmation
 * @param {Function} props.onCancel - Fonction appelée lors de l'annulation
 * @param {Object} props.messages - Messages personnalisés pour la boîte de dialogue
 */
const ConfirmDialog = ({ 
  show, 
  onConfirm, 
  onCancel,
  messages = {
    title: "Attention !!",
    message: "Vous avez demandé à fermer le formulaire, mais des données ont été modifiées.",
    subMessage: "Vos modifications seront perdues si vous ne les enregistrez pas.",
    confirmButton: "Ne pas enregistrer",
    cancelButton: "Revenir en arrière"
  }
}) => {
  if (!show) return null
  
  return (
    <dialog open className="modal">
      <div className="modal-box">
        <h3 className="font-bold text-lg">{messages.title}</h3>
        <p className="py-4">{messages.message}</p>
        <p className="py-4">{messages.subMessage}</p>
        <div className="modal-action">
          <button 
            onClick={onConfirm} 
            className="btn btn-error">
            {messages.confirmButton}
          </button>
          <button 
            onClick={onCancel} 
            className="btn btn-outline">
            {messages.cancelButton}
          </button>
        </div>
      </div>
    </dialog>
  )
}

export default ConfirmDialog